import React from 'react';
import styles from '../../../../refundStyles.module.scss';

const Footer = ({ children, className = 'rectification-refund-footer' }) => {
  return (
    <div className={`d-flex justify-content-between align-items-center w-100 ${styles[className]}`}>
      {children}
    </div>
  )
}

export default Footer;